import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { apiService } from '../../services/api';

const DashboardNavbar = ({ sidebarExpanded }) => {
    const [ notifications ] = useState(3);
    const { state, logout } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    
  // Helper function to get page title from path
  const getPageTitle = (path) => {
    const pageName = path.split('/')[1] || 'dashboard';
    return pageName.charAt(0).toUpperCase() + pageName.slice(1);
  };

  const handleLogout = async () => {
    try {
      const refreshToken = state.refreshToken;
      if (!refreshToken) throw new Error("Refresh token not available");
      await apiService.post("/api/auth/logout", state.token, { refreshToken });
    } catch (error) {
      console.error("Logout error:", error);
    }
    logout();
    navigate("/login");
  };
  

  return (
        <header 
        className="bg-white shadow-sm h-16 fixed top-0 right-0 left-0 z-10 transition-all duration-300" 
        style={{ paddingLeft: sidebarExpanded ? '240px' : '70px' }}
        >
        <div className="flex items-center justify-between px-6 h-full">
            <div>
            <h1 className="text-xl font-semibold text-primary-800">
                {getPageTitle(location.pathname)}
            </h1>
            </div>
            
            <div className="flex items-center space-x-4">
            {/* Search */}
            <div className="relative">
                <input 
                type="text" 
                placeholder="Search..." 
                className="bg-gray-100 rounded-lg py-2 pl-10 pr-4 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 w-48"
                />
                <svg className="w-4 h-4 text-gray-500 absolute left-3 top-2.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
            </div>
            
            {/* Notifications */}
            <button className="relative p-2 rounded-full hover:bg-gray-100">
                    <svg className="w-5 h-5 text-gray-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                    </svg>
                    {notifications > 0 && (
                    <span className="absolute top-0 right-0 w-4 h-4 rounded-full bg-primary-600 text-white text-xs source-sans-3 flex items-center justify-center">
                        {notifications}
                    </span>
                    )}
                </button>
                
                {/* Messages */}
                <button className="p-2 rounded-full hover:bg-gray-100">
                <svg className="w-5 h-5 text-gray-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
                </svg>
                </button>

                {/* Logout Button */}
                <button 
                    onClick={handleLogout} 
                    className="p-2 rounded-full hover:bg-gray-100"
                    title="Logout"
                >
                    <svg className="w-5 h-5 text-gray-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h6a2 2 0 012 2v1" />
                    </svg>
                </button>

                </div>
            </div>
        </header>
    )
};

export default DashboardNavbar;